/* eslint-disable no-unused-vars */
import { reactive } from "@vue/reactivity";
// import LZString from "lz-string";

import {
  ADD_MESSAGE,
  SET_CONVERSATION_HISTORY,
  SET_MESSAGES,
  SET_NUM_RECEIVED_MESSAGES_SEEN,
  SET_SCORING_CONVERSATION_HISTORY,
  TOGGLE_SIDEBAR,
  SET_SIDEBAR
} from "@/store/actions/chat";
import dayjs from "dayjs";

// TODO: Confirm this is working and below.
// TODO: Account for "user-initial-message" storage
// TODO: Account for "previous-suggested-responses"?
const state = reactive({
  sessionId: crypto.randomUUID(),
  messages: [],
  timeLastMessageSent:
    window.localStorage.getItem("time-previous-chat-message-sent") !== null
      ? window.localStorage.getItem("time-previous-chat-message-sent")
      : null,
  numReceivedMessagesSeen: 0,
  conversationHistory:
    window.localStorage.getItem("conversation-history") !== null
      ? JSON.parse(window.localStorage.getItem("conversation-history"))
          .reverse()
          .splice(0, 8)
      : [],
  scoringConversationHistory:
    window.localStorage.getItem("scoring-conversation-history") !== null
      ? JSON.parse(window.localStorage.getItem("scoring-conversation-history"))
          .reverse()
          .splice(0, 8)
      : [],
  sidebarOpen: false
});

const getters = {};

const actions = {};

const mutations = {
  [SET_CONVERSATION_HISTORY]: (state, value) => {
    state.conversationHistory = value;
    window.localStorage.setItem(
      "conversation-history",
      JSON.stringify(state.conversationHistory)
    );
  },
  [SET_SCORING_CONVERSATION_HISTORY]: (state, value) => {
    state.scoringConversationHistory = value;
    window.localStorage.setItem(
      "scoring-conversation-history",
      JSON.stringify(state.scoringConversationHistory)
    );
  },
  [SET_MESSAGES]: (state, value) => {
    state.messages = value;

    /*if (value.length > 0) {
      window.localStorage.setItem(
        "previous-chat-messages",
        JSON.stringify(state.messages)
      );

      state.timeLastMessageSent = dayjs();
      window.localStorage.setItem(
        "time-previous-chat-message-sent",
        state.timeLastMessageSent
      );
    }*/

    if (window.innerWidth > 1025) {
      state.numReceivedMessagesSeen = state.messages.filter(
        message => !message.fromUser
      ).length;
    }
  },
  [ADD_MESSAGE]: (state, value) => {

    // Skip adding message if it's from the user and the last message was also from the user
    if (value.fromUser && state.messages.length > 0) {
      const lastMessage = state.messages[state.messages.length - 1];
      if (lastMessage.fromUser) {
        return;
      }
    }

    state.messages.push(value);
    window.localStorage.setItem(
      "previous-chat-messages",
      JSON.stringify(state.messages)
    );

    if (value.fromUser) {
      state.timeLastMessageSent = dayjs();
      window.localStorage.setItem(
        "time-previous-chat-message-sent",
        state.timeLastMessageSent
      );
    } else {
      if (window.innerWidth > 1025) {
        ++state.numReceivedMessagesSeen;
      }
    }
  },
  [SET_NUM_RECEIVED_MESSAGES_SEEN]: (state, value) => {
    state.numReceivedMessagesSeen = value;
  },
  [TOGGLE_SIDEBAR]: state => {
    state.sidebarOpen = !state.sidebarOpen;
  },
  [SET_SIDEBAR]: (state, value) => {
    state.sidebarOpen = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
